export const config = {
    contactMail: 'help@joinmodernhealth.com',
};
